<div class="container-xxl article-status-bar-wrapper">
  <div class="hidden-tablet-down article-status-bar" [@visibilityChanged]="visible">
    <div class="progress-bar">
      <div class="progress-bar-progress" [style.width.%]="progress * 100"></div>
    </div>

    <div class="container-xxl">
      <div class="status-bar-content" [class.content-without-meta-items]="areMetaItemsEmpty">
        <div class="meta-items-title-wrapper">
          <div class="article-title copy-l" [innerHTML]="title"></div>
          @if (!areMetaItemsEmpty) {
            <mb-meta-items
              [metaItems]="metaItems"
              itemClass="btn btn-plain"
              (itemClicked)="metaItemClicked.emit($event)"
            ></mb-meta-items>
          }
        </div>

        <div class="action-container-wrapper">
          <mb-action-container
            class="inherit-color"
            [buttonItems]="buttonItems"
            [resource]="article"
            (actionClick)="actionClick.emit({ action: $event })"
          ></mb-action-container>
        </div>
      </div>
    </div>
  </div>
</div>
